const ACCENTED_CHARS_REGEX = /[àèéìòùÀÈÉÌÒÙ]/;

const decodeUnicodeEscapes = (value) =>
  String(value || '').replace(/\\u([0-9a-fA-F]{4})/g, (_, hex) =>
    String.fromCharCode(parseInt(hex, 16)),
  );

const stripAccents = (value) => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '');

const stripMelangeWord = (value) => String(value || '').replace(/\bmelange\b/gi, ' ').replace(/\s+/g, ' ').trim();

const toTitleCase = (value) =>
  String(value || '').replace(/[A-Za-zÀ-ÖØ-öø-ÿ]+/g, (token) => {
    const lower = token.toLowerCase();
    return lower.charAt(0).toUpperCase() + lower.slice(1);
  });

const buildAccentMap = (value) => {
  const map = {};
  const tokens = String(value || '').match(/[A-Za-zÀ-ÖØ-öø-ÿ]+/g) || [];

  tokens.forEach((token) => {
    if (!ACCENTED_CHARS_REGEX.test(token)) return;
    const accentedUpper = token.toUpperCase();
    const plainUpper = stripAccents(accentedUpper);
    map[plainUpper] = accentedUpper;
  });

  return map;
};

const applyAccentMapToTarget = (target, accentMap) => {
  const value = String(target || '');

  return value.replace(/[A-Za-zÀ-ÖØ-öø-ÿ]+/g, (token) => {
    const key = stripAccents(token.toUpperCase());
    const replacement = accentMap[key];
    if (!replacement) return token;

    if (token === token.toLowerCase()) return replacement.toLowerCase();
    if (token === token.toUpperCase()) return replacement;

    return replacement.charAt(0) + replacement.slice(1).toLowerCase();
  });
};

export const resolveProductDisplayName = (nomeArticolo, pName) => {
  const decodedNomeArticolo = decodeUnicodeEscapes(nomeArticolo);
  const decodedPName = decodeUnicodeEscapes(pName);
  const nomeWithoutMelange = stripMelangeWord(decodedNomeArticolo);

  if (!decodedPName) return toTitleCase(nomeWithoutMelange);
  if (!decodedNomeArticolo) return toTitleCase(decodedPName);

  if (!ACCENTED_CHARS_REGEX.test(decodedNomeArticolo)) {
    return toTitleCase(decodedPName);
  }

  const accentMap = buildAccentMap(decodedNomeArticolo);
  if (!Object.keys(accentMap).length) {
    return toTitleCase(decodedPName);
  }

  return toTitleCase(applyAccentMapToTarget(decodedPName, accentMap));
};
